module.exports = __webpack_public_path__ + "static/media/1-circle-dirty.69924087.svg";